import React, { useState, useEffect } from 'react';
import { TabletFilterContainer } from './shared/TabletFilterContainer';
import { TabletFilterField } from './shared/TabletFilterField';
import { TabletFilterSection } from './shared/TabletFilterSection';
import { FilterOption, SelectedItem } from './shared/TabletFilterOptionsList';

export interface ReceiptFilterData {
  number?: string;
  statuses?: string[];
}

interface ReceiptFilterProps {
  initialData?: ReceiptFilterData;
  onApply: (data: ReceiptFilterData) => void;
  onReset: () => void;
  onChange?: (data: ReceiptFilterData) => void;
  statusOptions: Array<{ value: string; label: string }>;
}

export const TabletReceiptFilter: React.FC<ReceiptFilterProps> = ({
  initialData,
  onChange,
  statusOptions,
}) => {
  const getStatusLabel = (statusId: string): string => {
    const option = statusOptions.find((opt) => opt.value === statusId);
    return option?.label || statusId;
  };

  const [receiptNumber, setReceiptNumber] = useState<string>(initialData?.number || '');
  const [selectedStatuses, setSelectedStatuses] = useState<SelectedItem[]>(
    initialData?.statuses?.map((status) => ({
      id: status,
      name: getStatusLabel(status),
    })) || [],
  );

  useEffect(() => {
    setReceiptNumber(initialData?.number || '');
    setSelectedStatuses(
      initialData?.statuses?.map((status) => ({
        id: status,
        name: getStatusLabel(status),
      })) || [],
    );
  }, [initialData]);

  const updateParentData = (number: string, statuses: SelectedItem[]) => {
    if (onChange) {
      const filterData: ReceiptFilterData = {};
      if (number !== '' && number !== undefined) {
        filterData.number = number;
      }
      if (statuses.length > 0) {
        filterData.statuses = statuses.map((item) => item.id);
      }
      onChange(filterData);
    }
  };

  const handleNumberChange = (value: string | number) => {
    const newNumber = String(value);
    setReceiptNumber(newNumber);
    updateParentData(newNumber, selectedStatuses);
  };

  const handleStatusesChange = (values: SelectedItem[]) => {
    setSelectedStatuses(values);
    updateParentData(receiptNumber, values);
  };

  const mappedStatusOptions: FilterOption[] = statusOptions.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  return (
    <TabletFilterContainer>
      <TabletFilterSection>
        <TabletFilterField
          type='text'
          value={receiptNumber}
          onChange={handleNumberChange}
          placeholder='Номер чека'
        />
      </TabletFilterSection>

      <TabletFilterSection>
        <TabletFilterField
          type='select'
          options={mappedStatusOptions}
          selectedValues={selectedStatuses}
          onChange={handleStatusesChange}
          showSearch={false}
        />
      </TabletFilterSection>
    </TabletFilterContainer>
  );
};
